export type BlogPost = {
  slug: string;
  title: string;
  metaTitle: string;
  metaDescription: string;
  description: string;
  image: string;
  date: string;
  readTime: string;
  category: string;
  enrollUrl: string;
  enrollButtonText: string;
  content: string;
  keywords: string[];
};

export const BLOG_POSTS: BlogPost[] = [
  {
    slug: 'best-ai-course-in-patna',
    title: 'Best AI Course in Patna | AI for Everyone - Transform Your Career with Generative AI',
    metaTitle: 'Best AI Course in Patna | AI for Everyone - Generative AI & AI Teacher Program',
    metaDescription:
      'Join the best AI course in Patna. AI for Everyone program covers Generative AI, LangChain, chatbots & more. No coding required. ₹500/month. Enroll now at Reviving India.',
    description:
      'Discover the best AI course in Patna. AI for Everyone helps you master Generative AI, build chatbots, and become an AI-enabled educator. No coding required.',
    image: '/ai-for-everyone.jpg',
    date: '2025-03-22',
    readTime: '5 min read',
    category: 'AI for Everyone',
    enrollUrl: '/gen-ai-course/enroll',
    enrollButtonText: 'Enroll in AI for Everyone',
    keywords: [
      'best AI course in Patna',
      'best AI course',
      'AI course Patna',
      'Generative AI course Patna',
      'AI for Everyone',
      'AI teacher program',
      'learn AI without coding',
    ],
    content: `
      <p>Looking for the <strong>best AI course in Patna</strong>? You're in the right place. Reviving India's <strong>AI for Everyone</strong> program is designed to make artificial intelligence accessible to teachers, students, and professionals—with <strong>no coding required</strong>.</p>

      <h2>Why Choose the Best AI Course in Patna?</h2>
      <p>Patna is emerging as an education hub, and <strong>AI skills</strong> are now essential for career growth. Our <strong>AI for Everyone</strong> course stands out as the <strong>best AI course in Patna</strong> because it:</p>
      <ul>
        <li>Covers <strong>Generative AI</strong>, chatbots, and LangChain from basics to advanced</li>
        <li>Requires <strong>no prior coding or technical background</strong></li>
        <li>Offers a 3-month, career-focused program at just ₹500 per month</li>
        <li>Includes placement support, resume building, and interview preparation</li>
        <li>Certifies you as an <strong>AI-enabled educator</strong> ready for the job market</li>
      </ul>

      <h2>What You'll Learn in This AI Course</h2>
      <p>Our <strong>best AI course</strong> curriculum includes:</p>
      <ul>
        <li><strong>Introduction to Generative AI</strong> – What is AI, how it works, real-world use cases</li>
        <li><strong>Chat Models & LLMs</strong> – GPT, Claude, Gemini, and how to use them</li>
        <li><strong>Prompt Engineering</strong> – Get better results from AI with clear instructions</li>
        <li><strong>AI Chatbots & RAG</strong> – Build intelligent systems without code</li>
        <li><strong>Agentic AI</strong> – AI that can think and act autonomously</li>
      </ul>

      <h2>Who Is This AI Course For?</h2>
      <p>Whether you're a <strong>school teacher</strong>, <strong>college professor</strong>, <strong>B.Ed student</strong>, or <strong>working professional</strong> looking to switch careers—this <strong>AI course in Patna</strong> is built for you. We help you become job-ready in 3 months.</p>

      <h2>Enroll in the Best AI Course in Patna Today</h2>
      <p>Don't wait. Start your journey in <strong>Generative AI</strong> and become part of the future of education. Limited seats available.</p>
    `,
  },
  {
    slug: 'best-python-course-in-patna',
    title: 'Best Python Course in Patna | Learn Python Programming from Basics to Advanced',
    metaTitle: 'Best Python Course in Patna | Python Programming - Fundamentals to Career Ready',
    metaDescription:
      'Join the best Python course in Patna. Learn Python from fundamentals to advanced. Backend development, data science, automation. Start your programming journey at Reviving India.',
    description:
      'Discover the best Python course in Patna. Master Python programming from basics to advanced. Build real-world applications and kickstart your tech career.',
    image: '/learn-with-us-2.jpg',
    date: '2025-03-22',
    readTime: '5 min read',
    category: 'Python Programming',
    enrollUrl: '/python-course',
    enrollButtonText: 'Enroll in Python Course',
    keywords: [
      'best Python course in Patna',
      'best Python course',
      'Python course Patna',
      'learn Python programming',
      'Python for beginners',
      'Python backend development',
      'Python data science',
    ],
    content: `
      <p>Looking for the <strong>best Python course in Patna</strong>? Reviving India's <strong>Python Programming</strong> program helps you go from zero to job-ready—whether you want to build web apps, work with data, or automate workflows.</p>

      <h2>Why Choose the Best Python Course in Patna?</h2>
      <p>Python is the most versatile programming language for <strong>web development</strong>, <strong>data science</strong>, <strong>automation</strong>, and <strong>AI</strong>. Our <strong>best Python course in Patna</strong> stands out because it:</p>
      <ul>
        <li>Teaches <strong>Python fundamentals</strong> – variables, loops, functions, and data structures</li>
        <li>Covers <strong>advanced Python</strong> – comprehensions, error handling, and concurrency</li>
        <li>Prepares you for <strong>Backend Developer</strong>, <strong>Data Engineer</strong>, and <strong>Data Scientist</strong> roles</li>
        <li>Includes hands-on projects and real-world applications</li>
        <li>Offers a clear path from basics to career-ready skills</li>
      </ul>

      <h2>What You'll Learn in This Python Course</h2>
      <p>Our <strong>best Python course</strong> curriculum includes:</p>
      <ul>
        <li><strong>Python Fundamentals</strong> – Syntax, loops, conditions, functions, JSON handling</li>
        <li><strong>Advanced Python</strong> – Comprehensions, error handling, threads, and processes</li>
        <li><strong>Career Paths</strong> – Backend development, data engineering, data analysis, data science</li>
        <li><strong>Real-world projects</strong> – Build automation scripts, data pipelines, and backend systems</li>
      </ul>

      <h2>Who Is This Python Course For?</h2>
      <p>Whether you're a <strong>student</strong>, <strong>fresher</strong>, or <strong>professional</strong> looking to switch to tech—this <strong>Python course in Patna</strong> is designed for you. No prior programming experience required.</p>

      <h2>Enroll in the Best Python Course in Patna Today</h2>
      <p>Start your programming journey with the <strong>best Python course</strong>. Build in-demand skills and open doors to high-growth tech careers.</p>
    `,
  },
  {
    slug: 'best-robotics-course-in-patna',
    title: 'Best Robotics Course in Patna | Learn Robotics, Arduino & IoT from Scratch',
    metaTitle: 'Best Robotics Course in Patna | Robotics, Arduino, IoT - Hands-on Projects',
    metaDescription:
      'Join the best robotics course in Patna. Learn Arduino, sensors, motors, and IoT. Build line followers, smart irrigation, home automation. Enroll at Reviving India.',
    description:
      'Discover the best robotics course in Patna. Learn robotics from basics—Arduino, sensors, motors. Build real projects like line followers and smart systems.',
    image: '/beyond/live-events.jpg',
    date: '2025-03-22',
    readTime: '5 min read',
    category: 'Robotics & IoT',
    enrollUrl: '/robotics-course',
    enrollButtonText: 'Enroll in Robotics Course',
    keywords: [
      'best robotics course in Patna',
      'best robotics course',
      'robotics course Patna',
      'learn Arduino',
      'IoT course Patna',
      'robotics for beginners',
      'line follower robot',
    ],
    content: `
      <p>Looking for the <strong>best robotics course in Patna</strong>? Reviving India's <strong>Robotics</strong> program takes you from electronics basics to building real robots—<strong>Arduino</strong>, sensors, motors, and <strong>IoT</strong>.</p>

      <h2>Why Choose the Best Robotics Course in Patna?</h2>
      <p>Robotics and <strong>IoT</strong> are shaping the future of automation. Our <strong>best robotics course in Patna</strong> stands out because it:</p>
      <ul>
        <li>Covers <strong>electronics fundamentals</strong> – voltage, current, breadboard, components</li>
        <li>Teaches <strong>Arduino and microcontrollers</strong> – programming and interfacing</li>
        <li>Includes <strong>sensors and actuators</strong> – IR, PIR, motors, servo, relays</li>
        <li>Guides you through <strong>real projects</strong> – Line Follower, Obstacle Avoidance, Smart Irrigation, Home Automation</li>
        <li>Prepares you for <strong>Robotics Engineer</strong>, <strong>Embedded Systems</strong>, and <strong>IoT Engineer</strong> roles</li>
      </ul>

      <h2>What You'll Learn in This Robotics Course</h2>
      <p>Our <strong>best robotics course</strong> curriculum includes:</p>
      <ul>
        <li><strong>Introduction to Robotics</strong> – Applications, components, types of robots</li>
        <li><strong>Electronics & Microcontrollers</strong> – Arduino, Raspberry Pi, AVR</li>
        <li><strong>Sensors & Actuators</strong> – IR, PIR, DC motor, servo, relays</li>
        <li><strong>Robot Control & Programming</strong> – Arduino coding, motor control, automation logic</li>
        <li><strong>Robotics Projects</strong> – Line Follower, Obstacle Avoidance, Voice-Controlled Robot, Smart Irrigation</li>
      </ul>

      <h2>Who Is This Robotics Course For?</h2>
      <p>Whether you're a <strong>student</strong> interested in <strong>STEM</strong>, an <strong>engineer</strong> exploring automation, or a <strong>maker</strong> who wants to build robots—this <strong>robotics course in Patna</strong> is for you.</p>

      <h2>Enroll in the Best Robotics Course in Patna Today</h2>
      <p>Start building robots with the <strong>best robotics course</strong>. Hands-on learning, real projects, and a clear path to a career in robotics and IoT.</p>
    `,
  },
];
